import React from "react";
import styles from "./index.module.scss";
import {
  FaFacebookSquare,
  FaLinkedin,
  FaInstagramSquare,
  FaTwitter,
} from "react-icons/fa";
import { IoIosMail } from "react-icons/io";
import { IoCallSharp } from "react-icons/io5";
import { toast } from "react-toastify";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const HomepageFooter = () => {

  // const navigate = useNavigate();
  return (
    <div className={styles.footer_container}>
      <div className={styles.footer_sub_container}>
        {/* 1st div */}
        <div styles={styles.footer_description}>
          <img
          style={{width:"200px",}}
            src={
            "/assets/images/laags.png"
            }
            alt="Lagos State"
          />
          <Typography>
            The Lagos State Examinations Board manages all Lagos State
            Exams. <br></br> From Primary School (CAS) and Junior Secondary
            (B.E.C.E) to Public <br></br>  Service (Promotional Exams) and Screening/Model College Entrance <br></br>  Exams.
          </Typography>
          <div className={styles.icons}>
            <FaFacebookSquare size={30} />
            <FaInstagramSquare size={30} />
            <FaLinkedin size={30} />
            <FaTwitter size={30} />
          </div>
        </div>
        {/* 2nd div */}
        <div className={styles.services}>
          <Typography  fontWeight={600} variant="h6">Services</Typography>
          <a style={{textDecoration:'none'}}  href="#">
            {" "}
            <Typography > B.E.C.E</Typography>
          </a>
          <a href="#">
            <Typography>CAS/Placement</Typography>
          </a>
          <a href="#">
            <Typography>Public Service</Typography>
          </a>
          <a href="#">
            {" "}
            <Typography>Screening/Model College</Typography>{" "}
          </a>
          <Typography
            onClick={() => {
              toast.error("This Exam is not available");
            }}
          >
            Apply for School Code{" "}
          </Typography>
          <Typography
            onClick={() => {
              toast.error("This Exam is not available");
            }}
          >
            TEDAC
          </Typography>
        </div>

        <div className={styles.contact}>
          <Typography fontWeight={600} variant="h6">Contact Us</Typography>
          <div className={styles.contactItems}>
            <IoCallSharp />
            <a href="callto:09057958530">09057958530</a>
          </div>
          <div className={styles.contactItems}>
            <IoCallSharp />
            <a href="callto:08078551122">08078551122</a>
          </div>
          <div className={styles.contactItems}>
            <IoCallSharp />
            <a href="callto:08125757526">08125757526</a>
          </div>
          <div className={styles.contactItems}>
            <IoCallSharp />
            <a href="callto:08060086325">08060086325</a>
          </div>
        </div>

        <div className={styles.enqueries}>
          <Typography  fontWeight={600} variant="h6">Further Enqueries</Typography>
          <div className={styles.enqueriesItems}>
            <IoIosMail size={25} />{" "}
            <a href="mailto:placement@lagosstate.gov.ng">lagosexaminationsboard@gmail.com</a>
          </div>

          <div className={styles.enqueriesItems}>
            <IoIosMail size={25} />{" "}
            <a href="mailto:placement@lagosstate.gov.ng">placement@lagosstate.gov.ng</a>
          </div>
          <div className={styles.enqueriesItems}>
            <IoIosMail size={25} /> 
            <a href="mailto:placement@lagosstate.gov.ng">bece@lagosstate.gov.ng</a>
          </div>
        </div>
      </div>
      <div className={styles.copyright}>
        <Typography>&copy; 2024 LAGOS STATE EXAMINATIONS BOARD. All rights reserved.</Typography>
      </div>
    </div>
  );
};

export default HomepageFooter;
